









































import {Component, Prop, Vue} from 'vue-property-decorator';
import {ESettori} from "@/types";
import {mapGetters} from "vuex";

@Component({
    components: {},
    name: "CompanyAnnouncement",
    computed:{
        ...mapGetters({
            profile: 'profile'
        })
    }
})
export default class CompanyAnnouncement extends Vue {
    esettori = ESettori
    @Prop(Object) private readonly announcement!: any;
    @Prop(Boolean) private readonly show_actions!: boolean;
}

